import type { Xinglet } from '@xing-com/crate-xinglet';

import { MasterDirectoryJobRolePage } from './job-role';

export default class MasterDirectoryJobRole implements Xinglet {
  public getComponent() {
    return () => <MasterDirectoryJobRolePage />;
  }
}
